/**
 * Celeste.js - Site functionality
 * Consolidated and optimized for better performance
 */

// Execute all functions when DOM is fully loaded
document.addEventListener("DOMContentLoaded", function() {
  // 1. Add page-specific classes to body
  addBodyClasses();
  
  // 2. Initialize FAQ accordion functionality
  initFaqAccordion();
  
  // 3. Reorganize product elements on cart page
  setupProductContainer();
});

/**
 * Adds body classes based on URL path
 * - Adds last path segment as a class (with special characters replaced by hyphens)
 * - Adds 'subpage' class for any non-root page
 */
function addBodyClasses() {
  // Get URL path information
  const path = window.location.pathname;
  const pathnameParts = path.split('/').filter(Boolean);
  const urlPath = pathnameParts.length > 0 ? pathnameParts.pop() : '';
  
  // Add class based on last URL segment if it exists
  if (urlPath) {
    document.body.classList.add(urlPath.replace(/[^a-zA-Z0-9]/g, '-'));
  }
  
  // Add 'subpage' class if not on root page
  if (path !== "/" && path !== "") {
    document.body.classList.add("subpage");
  }
}

/**
 * Initializes FAQ accordion behavior
 */
function initFaqAccordion() {
  const faqList = document.querySelector('ul.celeste-faq');
  
  if (!faqList) return;
  
  faqList.addEventListener('click', function(e) {
    const clickedLi = e.target.closest('li');
    
    if (clickedLi && faqList.contains(clickedLi)) {
      // Close other open items
      faqList.querySelectorAll('li.open').forEach(li => {
        if (li !== clickedLi) {
          li.classList.remove('open');
        }
      });
      
      // Toggle clicked item
      clickedLi.classList.toggle('open');
    }
  });
}

/**
 * Sets up product container on cart page
 * Reorganizes quantity form and submit button into a single container
 */
function setupProductContainer() {
  const quantityForm = document.getElementById('Quantity-Form-template--19428201038039__main');
  const submitButton = document.getElementById('ProductSubmitButton-template--19428201038039__main');
  
  // Exit if required elements don't exist
  if (!quantityForm || !submitButton) return;
  
  const buttonParent = submitButton.parentNode;
  
  // Create container with proper class
  const container = document.createElement('div');
  container.className = 'quantity-button-container';
  
  // Move elements to new container
  container.appendChild(quantityForm.cloneNode(true));
  container.appendChild(submitButton.cloneNode(true));
  
  // Remove original elements after cloning
  quantityForm.parentNode.removeChild(quantityForm);
  buttonParent.removeChild(submitButton);
  
  // Add container to DOM
  buttonParent.appendChild(container);
}
